export default {
  access: [],
  agentAccess: [],
  errors: null
};
